import { Deserializable } from '../deserializable';
import { FiaApplication } from './fia-application';
import { QueueNotification } from './queue-notification';
import { UserBasicDetails } from './user-basic-details';
import { UserProfile } from './user-profile';
import { Users } from './users';

export class UserFullDetails implements Deserializable {
  public user: Users = new Users();
  public spouse: UserBasicDetails = new UserBasicDetails();
  public profile: UserProfile = new UserProfile();
  public fiaApplications: FiaApplication[] = [];
  public queueNotifications: QueueNotification[] = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
